import { createEntityAdapter } from '@reduxjs/toolkit';
import IPayrollCostCenter from 'types/company/payroll/IPayrollCostCenter';

const costCentersAdapter = createEntityAdapter<IPayrollCostCenter>({
  selectId: costCenter => costCenter.id,
});

export default costCentersAdapter;
